import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';

import { buyActions, useStore } from '@modules';
import { VerificationStatusesEnum } from '@modules/user/types';

import OperationBlock from '@containers/OperationBlock';
import Transactions from '@containers/Transactions';
import WalletLayout from '@layouts/WalletLayout';

import Cryptocurrencies from './Cryptocurrencies';
import useRedirectNotifications from './useRedirectNotifications';

import style from './Portfolio.scss';

const cn = bemCssModules(style, 'Portfolio');
const { complete, under_review } = VerificationStatusesEnum;

export const Portfolio: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const [{ user, transactions }, dispatch] = useStore();
  const userData = user.data;
  const documentStatus = userData?.checks.document;
  useRedirectNotifications();

  useEffect(() => {
    dispatch(buyActions.resetBuyStatus());
  }, []);

  const { list, loaders } = transactions;

  const KYCIsComplete = documentStatus === complete;
  const noTransactions = Object.keys(list).length === 0;

  const title = KYCIsComplete
    ? loaders.getTransactions === false && noTransactions && t('portfolio.first_transaction')
    : documentStatus === under_review
    ? t('portfolio.verification_in_progress_title')
    : t('public.complete_verification');

  const header = (
    <div className={cn('header')}>
      {title && <h1 className={cn('title')}>{title}</h1>}
      {KYCIsComplete && <OperationBlock className={cn('operation-block')} />}
    </div>
  );

  return (
    <WalletLayout
      header={header}
      additionalBanner={!KYCIsComplete && <Cryptocurrencies className={cn('banner')} />}
    >
      <div className={cn(null, [className])}>
        <div className={cn('content-wrapper')}>
          {(!KYCIsComplete || noTransactions) && (
            <Cryptocurrencies className={cn('cryptocurrencies')} />
          )}
          <Transactions title={t('transaction.latest_transactions')} />
        </div>
      </div>
    </WalletLayout>
  );
};

export default Portfolio;
